var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.mandate_details") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "min-w-100 align-items-center mt-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "d-flex justify-content-start" },
                    [
                      _c("back-button", {
                        staticClass: "btnFilter_2 mr-2",
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "back-button btnFilter_2 mr-2",
                          on: { click: _vm.onRefresh },
                        },
                        [
                          _c("i", { staticClass: "fa-solid fa-rotate-right" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.rfrsh")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "d-flex justify-content-end" },
                    [
                      _vm.showAddButtons
                        ? [
                            _vm.signedPdfBase64
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "back-button btnFilter_2 mr-2",
                                    on: { click: _vm.sendSignedPdfCopy },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-envelope",
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("mandate.send_signed_pdf_copy")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "back-button btnFilter_2 mr-2",
                                on: { click: _vm.exportAuditTrailPdf },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-file-pdf",
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("mandate.export_detail_pdf")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.details.type === 2
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "back-button btnFilter_2 mr-2",
                                    on: { click: _vm.newPaymentSchedule },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-plus",
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("mandate.add_payment_schedule")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "back-button btnFilter_2",
                                on: { click: _vm.newTransaction },
                              },
                              [
                                _c("i", { staticClass: "fa-solid fa-plus" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("mandate.add_collection")) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        : _vm.showResendSignatureButton
                        ? [
                            _vm.signedPdfBase64
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "back-button btnFilter_2 mr-2",
                                    on: { click: _vm.sendSignedPdfCopy },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-envelope",
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("mandate.send_signed_pdf_copy")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "back-button btnFilter_2 mr-2",
                                on: { click: _vm.exportAuditTrailPdf },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-file-pdf",
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("mandate.export_detail_pdf")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "back-button btnFilter_2",
                                on: { click: _vm.resendSignatureEmail },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-envelope",
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("mandate.resend_sign_email")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        : [
                            _vm.signedPdfBase64
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "back-button btnFilter_2 mr-2",
                                    on: { click: _vm.sendSignedPdfCopy },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-envelope",
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("mandate.send_signed_pdf_copy")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "back-button btnFilter_2 mr-2",
                                on: { click: _vm.exportAuditTrailPdf },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-file-pdf",
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("mandate.export_detail_pdf")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm.activateSpinner ? _c("spinner") : _vm._e(),
              _vm._v(" "),
              [
                _c(
                  "b-row",
                  { staticClass: "justify-content-center" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "mt-3", attrs: { cols: "12" } },
                      [
                        _c(
                          "div",
                          { staticClass: "outline-content" },
                          [
                            _c(
                              "form-accordion",
                              {
                                attrs: {
                                  title: _vm.$t("mandate.mandate_info"),
                                  isTitleUpperCase: false,
                                },
                              },
                              [
                                _c(
                                  "b-row",
                                  {
                                    staticClass: "form-group",
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _vm.isEditMode
                                          ? [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "mandate.unique_mandate_rf"
                                                    ),
                                                  },
                                                  model: {
                                                    value: _vm.editable.UMR,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editable,
                                                        "UMR",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "editable.UMR",
                                                  },
                                                }
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "mandate.unique_mandate_rf"
                                                    ),
                                                    inputValue:
                                                      _vm.details.UMR || "—",
                                                  },
                                                }
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "mandate_details.type_transaction"
                                            ),
                                            inputValue: _vm.details.type
                                              ? _vm.$t(
                                                  "mandate_details.type_transaction_" +
                                                    _vm.details.type
                                                )
                                              : "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "mandate_details.status"
                                            ),
                                            inputValue:
                                              _vm.details.status || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "mandate_details.creation_date"
                                            ),
                                            inputValue:
                                              _vm.details.creation_date || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "mandate_details.date_signed"
                                            ),
                                            inputValue:
                                              _vm.details.signed_date || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "mandate_details.cancel_date"
                                            ),
                                            inputValue:
                                              _vm.details.cancelled_date || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "mandate.underlying_contract_id"
                                            ),
                                            inputValue:
                                              _vm.details.id_contract || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "mandate_details.message_type"
                                            ),
                                            inputValue:
                                              _vm.details.message_type || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _vm.isEditMode
                                          ? [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "mandate-edit-language",
                                                  },
                                                },
                                                [_vm._v("Langue du mandat")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.editable.lang,
                                                      expression:
                                                        "editable.lang",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    id: "mandate-edit-language",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.$set(
                                                        _vm.editable,
                                                        "lang",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    { attrs: { value: "" } },
                                                    [_vm._v("Ne pas modifier")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.mandateLanguageOptions,
                                                    function (option) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: option.code,
                                                          domProps: {
                                                            value: option.code,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                option.label
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      "Langue du mandat",
                                                    inputValue:
                                                      _vm.mandateLanguageLabel(
                                                        _vm.details.lang
                                                      ),
                                                  },
                                                }
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _vm.isEditMode
                                          ? [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "mandate_details.reason"
                                                    ),
                                                  },
                                                  model: {
                                                    value: _vm.editable.reason,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editable,
                                                        "reason",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editable.reason",
                                                  },
                                                }
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "mandate_details.reason"
                                                    ),
                                                    inputValue:
                                                      _vm.details.reason,
                                                  },
                                                }
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _vm.details.reject_reason
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: "Reject Reason",
                                                inputValue:
                                                  _vm.details.reject_reason,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "mx-auto" }),
                            _vm._v(" "),
                            _c(
                              "form-accordion",
                              {
                                attrs: {
                                  title: _vm.$t("mandate.cdtr_info"),
                                  isTitleUpperCase: false,
                                },
                              },
                              [
                                _c(
                                  "b-row",
                                  {
                                    staticClass: "form-group",
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _vm.isEditMode
                                          ? [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      _vm.$t(
                                                        "mandate.cdtr_name"
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editable.cdtr_name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editable,
                                                        "cdtr_name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editable.cdtr_name",
                                                  },
                                                }
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      _vm.$t(
                                                        "mandate.cdtr_name"
                                                      ),
                                                    inputValue:
                                                      _vm.details.cdtr_name ||
                                                      "—",
                                                  },
                                                }
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _vm.isEditMode
                                          ? [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "administration.identifier"
                                                    ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editable
                                                        .cdtr_identifier,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editable,
                                                        "cdtr_identifier",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editable.cdtr_identifier",
                                                  },
                                                }
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "administration.identifier"
                                                    ),
                                                    inputValue:
                                                      _vm.details
                                                        .cdtr_identifier || "—",
                                                  },
                                                }
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _vm.isEditMode
                                          ? [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "mandate.cdtr_ref_name"
                                                    ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editable.cdtr_ref,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editable,
                                                        "cdtr_ref",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editable.cdtr_ref",
                                                  },
                                                }
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "mandate.cdtr_ref_name"
                                                    ),
                                                    inputValue:
                                                      _vm.details.cdtr_ref ||
                                                      "—",
                                                  },
                                                }
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass: "form-group",
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _vm.isEditMode
                                          ? [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "mandate.cdtr_addrss"
                                                    ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editable.cdtr_addr,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editable,
                                                        "cdtr_addr",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editable.cdtr_addr",
                                                  },
                                                }
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "mandate.cdtr_addrss"
                                                    ),
                                                    inputValue:
                                                      _vm.details.cdtr_addr ||
                                                      "—",
                                                  },
                                                }
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _vm.isEditMode
                                          ? [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      _vm.$t(
                                                        "mandate.cdtr_city"
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editable.cdtr_city,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editable,
                                                        "cdtr_city",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editable.cdtr_city",
                                                  },
                                                }
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      _vm.$t(
                                                        "mandate.cdtr_city"
                                                      ),
                                                    inputValue:
                                                      _vm.details.cdtr_city ||
                                                      "—",
                                                  },
                                                }
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _vm.isEditMode
                                          ? [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.cdtr_ctry"
                                                    ) || "Country of residence"
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.editable
                                                          .cdtr_country,
                                                      expression:
                                                        "editable.cdtr_country",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        var $$selectedVal =
                                                          Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function (o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function (o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                        _vm.$set(
                                                          _vm.editable,
                                                          "cdtr_country",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      },
                                                      _vm.onCdtrCountryChange,
                                                    ],
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.countryOptions,
                                                  function (opt) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: opt.iso2,
                                                        domProps: {
                                                          value: opt.iso2,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "countries." +
                                                                  opt.key
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      _vm.$t(
                                                        "mandate.cdtr_ctry"
                                                      ),
                                                    inputValue:
                                                      _vm.details
                                                        .cdtr_country || "—",
                                                  },
                                                }
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "mx-auto" }),
                            _vm._v(" "),
                            _c(
                              "form-accordion",
                              {
                                attrs: {
                                  title: _vm.$t("mandate.dbtr_info"),
                                  isTitleUpperCase: false,
                                },
                              },
                              [
                                _c(
                                  "b-row",
                                  {
                                    staticClass: "form-group",
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _vm.isEditMode
                                          ? [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      _vm.$t(
                                                        "mandate.dbtr_email"
                                                      ),
                                                    isMandatory: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editable.dbtr_email,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editable,
                                                        "dbtr_email",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editable.dbtr_email",
                                                  },
                                                }
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      _vm.$t(
                                                        "mandate.dbtr_email"
                                                      ),
                                                    inputValue:
                                                      _vm.details.dbtr_email ||
                                                      "-",
                                                  },
                                                }
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("b-col"),
                                    _vm._v(" "),
                                    _c("b-col"),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass: "form-group",
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel:
                                              _vm.$t("mandate.dbtr_name"),
                                            inputValue:
                                              _vm.details.dbtr_name || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel:
                                              _vm.$t("mandate.dbtr_iban"),
                                            inputValue:
                                              _vm.details.dbtr_iban || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel:
                                              _vm.$t("mandate.dbtr_id_cd"),
                                            inputValue:
                                              _vm.details.dbtr_id || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass: "form-group",
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "mandate.dbtr_addrss"
                                            ),
                                            inputValue:
                                              _vm.details.dbtr_addr || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel:
                                              _vm.$t("mandate.dbtr_city"),
                                            inputValue:
                                              _vm.details.dbtr_city || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "mandate.dbtr_country"
                                            ),
                                            inputValue:
                                              _vm.details.dbtr_country || "—",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass: "form-group",
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _vm.signedPdfBase64
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn w-auto px-4 btn-tertiary mb-2",
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.downloadSignedPdf.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t("mandate.signature")
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "mx-auto" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "history-no-padding" },
                              [
                                _c(
                                  "form-accordion",
                                  {
                                    attrs: {
                                      title: _vm.$t("mandate_details.history"),
                                      isTitleUpperCase: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "table-wrap" },
                                      [
                                        _c("b-table", {
                                          attrs: {
                                            striped: "",
                                            responsive: "",
                                            items: _vm.history,
                                            fields: _vm.historyFields,
                                            "empty-text": _vm.$t(
                                              "common.security.no_result"
                                            ),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "mx-auto" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "history-no-padding" },
                              [
                                _c(
                                  "form-accordion",
                                  {
                                    attrs: {
                                      title: "Collections",
                                      isTitleUpperCase: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "table-wrap" },
                                      [
                                        _c("b-table", {
                                          attrs: {
                                            striped: "",
                                            responsive: "",
                                            items: _vm.collections,
                                            fields: _vm.collectionFields,
                                            "empty-text":
                                              "No collections found for this mandate.",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.canEditOrCancel
                              ? _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "form-group justify-content-end",
                                  },
                                  [
                                    !_vm.isEditMode
                                      ? [
                                          _c(
                                            "b-col",
                                            {
                                              attrs: {
                                                lg: "2",
                                                "offset-lg": "8",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "lg",
                                                  },
                                                  on: {
                                                    click: _vm.enterEditMode,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-solid fa-pen-to-square",
                                                    attrs: { size: "17px" },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("mandate.edit")
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "2" } },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click:
                                                      _vm.confirmCancelMandate,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-solid fa-xmark",
                                                    attrs: { size: "17px" },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("mandate.cancel")
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "b-col",
                                            {
                                              attrs: {
                                                lg: "2",
                                                "offset-lg": "8",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "lg",
                                                    disabled:
                                                      _vm.activateSpinner,
                                                  },
                                                  on: {
                                                    click: _vm.confirmSendEdit,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-light fa-paper-plane",
                                                    attrs: { size: "17px" },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "mandate.send"
                                                        ) || "Send"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { sm: "2" } },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    variant: "secondary",
                                                    disabled:
                                                      _vm.activateSpinner,
                                                  },
                                                  on: { click: _vm.cancelEdit },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "mandate.cancel"
                                                        ) || "Cancel"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }